import React from "react";

const Spinner = ({size}) => {
    return (
        <div
            className="spinner"
            style={{
                width: `${size}px`,
                height: `${size}px`,
                borderWidth: `${size * 0.08}px`,
            }}
        >
            <style jsx="true">
                {`
                    .spinner {
                        border: 4px solid #EEEEEE;
                        border-top: 4px solid #00ADB5;
                        border-radius: 50%;
                        animation: spin 2s linear infinite;
                    }
                    @keyframes spin {
                        0% {
                            transform: rotate(0deg);
                        }
                        100% {
                            transform: rotate(360deg);
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default Spinner;
